// extracted by mini-css-extract-plugin
export var addressFields = "_ji-0";
export var animationContainer = "_ji-1";
export var footer = "_ji-2";
export var lineItems = "_ji-3";
export var modalContent = "_ji-4";
export var orderName = "_ji-5";
export var strong = "_ji-6";
export var warning = "_ji-7";